import React, { useState, useEffect, useCallback, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import MeetingPrepBattleCard from "../subTabs/MeetingPrepBattleCard";
import GenericTable from "../../genericComponents/genericTableComp/GenericTable";
import { useUser } from "../../../../context/UserContext";
import "./AutoNurture.css";
import ScHeaderComp from "../../genericComponents/genericTableComp/genericTableScHeader/ScHeaderComp";
import {
  formatDateForRecentDevelopments,
  getUrlDetailsObj,
  getUserStatsObject,
  recordActivity,
} from "../../../../services/commonService";
import { Button } from "react-bootstrap";
import * as FeatherIcon from "react-feather";
import iq_api_v2 from "../../../../services/iqApiV2";
import { IQ_API_V2_BASE_URL } from "../../../../config/apiConfig";
import { useBanner } from "../../../../context/BannerContext";
import useAuth from "../../../../hooks/useAuth";
import ResizableDivForTag from "../../uiUtils/resizeobs/ResizableDivForTag";
import ToggleSwitch2 from "../../genericComponents/ToggleSwitch/ToggleSwitch2";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import GenerateNurtureCard from "../SideCardsForAutoNurture/GenerateNurtureCard";
import { FetchAutoNurtureRequest, updateAutoNurtureStatus } from "../../../../store/features/actions/autoNurture/autoNurtureActions";
import iq_auto_nurture_api from "../../../../services/iqAutoNurtureApi";
import { AccountListContext } from "../../../../context/AccountListContext";
import AutoNurtureActivity from "./ongoingOrCompletedNurture/AutoNurtureActivity";
import PreviewAutoNurture from "./ongoingOrCompletedNurture/PreviewAutoNurture";
import NoDataComp from "../../genericComponents/uiElements/NoDataComp";
import { label } from "jscharting";
import AccessField from "../../AccountDetails/Opportunities/accessEmailComp/AccessField";
import TagOverflowHandlerV2 from "../../uiUtils/TagOverflowHandlerV2";
import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";
import TextWithTooltip from "../../GlobalContacts/TextWithTooltip";
import { formatDateToYMD } from "../../../../utilities/dateUtils";

const randomIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="top_tab_icon"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#535458"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line>
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
    <line x1="12" y1="22.08" x2="12" y2="12"></line>
  </svg>
);

function AutoNurture() {
  useAuth();

  const currentUrl = useLocation().pathname;
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);
  const { updateMyReportContext } = useContext(AccountListContext);
  const { clientName, accountId, accountName } = useParams();
  const { user } = useUser();
  const showBanner = useBanner();
  const [openGenerateNuture, setOpenGenerateNurture] = useState(false);
  const [isCalendarConnected, setIsCalendarDataConnected] = useState(false);
  const [outlookEmail, setOutlookEmail] = useState('')
  const [isCalendarDataLoading, setIsCalendarDataLoading] = useState(null);
  const [showExternalOnly, setShowExternalOnly] = useState(false);
  const [toggleStates, setToggleStates] = useState({});
  // const [selectedRows, setSelectedRows] = useState([]);
  const tabConfig = [
    // {
    //   key: "preview_auto_nurture",
    //   label: "Preview",
    //   Component: () => <PreviewAutoNurture campaignId={currentCampaignId} />,
    //   icon: randomIcon,
    //   tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
    // },
    // { key: "metting_summary", label: "Meeting Summary", Component: () => <MeetingSummaryCard {...commonProps} />, icon: randomIcon,tagIcon:<img src="/img/blueDocIcon.svg" width="16"/>  },
    // {
    //   key: "nuture_activity",
    //   label: "Activity",
    //   Component: () =>                  <GenerateNurtureCard
    //               campaignID={currentCampaignId}
    //               setOpenGenerateNurture={setShowMoreModal}
    //             />,
    //   icon: randomIcon,
    //   tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
    // },
  ];
  const [activeTab, setActiveTab] = useState(tabConfig?.[0]?.key);

  const dispatch = useDispatch();

  const { autoNurtureData, autoNurtureLoading } = useSelector(
    (state) => state?.autoNurtureReducer
  );

  const [filters, setFilters] = useState({});
  const [tabData, setTabData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // Search input state
  const [isMounted, setIsMounted] = useState(false);
  const [showMoreModal, setShowMoreModal] = useState(false);

  const [currentCampaignId, setCurrentCampaignId] = useState(null);
  const [currRow, setCurrRow] = useState();

  const fetchOutlookToken = async (user_id) => {
    if (user_id) {
      const outlook_data = await iq_api_v2.get(`/outlook/has_valid_token?user_id=${user_id}`);
      // console.log("outlook_data?.data : ", outlook_data?.data )
      return outlook_data;
    }
  };

  useEffect(() => {
    const getOutlookToken = async () => {
      if (user?.id) {
        const outlook_data = await fetchOutlookToken(user?.id);
        const is_connected = (outlook_data?.data?.is_valid == 1) ? true : false;
        const outlook_email = outlook_data?.data?.email ? outlook_data?.data?.email : "";

        setOutlookEmail(outlook_email)
        setIsCalendarDataConnected(is_connected)
        // setIsCalendarDataLoading(true)
        setTimeout(() => {
          //  setIsCalendarDataLoading(false)
        }, 30000); // wait for 30 seconds
      }
    };
    getOutlookToken();
  }, [user?.id]);

  const handleOutlookLogin = () => {
    const pageAfterLoginUrl = window.location.href;

    const afterLoginPageParams = { clientName, accountId, accountName };
    localStorage.removeItem("afterLoginPageParams");
    localStorage.setItem(
      "afterLoginPageParams",
      JSON.stringify(afterLoginPageParams)
    );
    localStorage.setItem("pageAfterLoginUrl", pageAfterLoginUrl);

    const loginWindow = window.open(
      IQ_API_V2_BASE_URL + "/outlook/login",
      "OutlookLogin",
      "width=600,height=500"
    );

    // 🔁 Polling to detect window close
    const checkPopupClosed = setInterval(() => {
      if (loginWindow.closed) {
        clearInterval(checkPopupClosed);
        window.location.reload(); // 🔄 Reload the current page
      }
    }, 500);
  };

  const [activeSwitchId, setActiveSwitchId] = useState(null);

  const changeStatus = async (record_id) => {
    const flg = toggleStates[record_id] == true ? 0 : 1;

    try {
      const response = await iq_auto_nurture_api.post(
        "/campaign/update",
        {
          c_id: record_id,
          status: flg,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json", // Matches your curl
          },
        }
      );

      let result = response?.data ?? [];

      dispatch(updateAutoNurtureStatus(record_id,flg))

      return result;
    } catch (error) {
      console.log(error);
      console.error("Fetch Account details error:", error);
      throw error;
    }
  };

  const handleToggle = async(record_id) => {
    console.log(record_id);
    setToggleStates((prev) => ({
      ...prev,
      [record_id]: !prev[record_id], // flip the value for that row
    }));

    // const flg = toggleStates?.record_id == true ? false : true

     await changeStatus(record_id);
  };

  const [selectedOpportunity, setSelectedOpportunity] = useState({
    opportunityIds: null,
  });
  // Tab configuration for side modal
  const commonProps = {
    opportunityIds: selectedOpportunity.opportunityIds,
    opportunityId: selectedOpportunity.opportunityId || "",
    selectedOpportunity: selectedOpportunity.opportunityInfo || {},
  };

  // Fetch opportunities on mount
  useEffect(() => {
    setIsMounted(true);
    if (user?.id) {
      dispatch(
        FetchAutoNurtureRequest({ clientName, accountName, userId: user?.id })
      );
    }
    return () => setIsMounted(false);
  }, [clientName, accountName, user?.id]);

  useEffect(() => {
    if (autoNurtureData) {
      const mapped_key = {};
      autoNurtureData.map((d) => {
        mapped_key[d._id] = d.active_status ? true : false;
      });
      setToggleStates(mapped_key);
    }
  }, [autoNurtureData]);

  useEffect(() => {
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const handleMessage = async (event) => {
      if (event.data === "refresh-parent") {
        const outlook_data = await fetchOutlookToken(user?.id);
        const is_connected = (outlook_data?.data?.is_valid == 1) ? true : false;
        const outlook_email = outlook_data?.data?.email ? outlook_data?.data?.email : "";
        setOutlookEmail(outlook_email);
        setIsCalendarDataConnected(is_connected);

        showBanner({
          message:
            "Outlook Connected, Your data will start appearing here in a few minutes!",
          title: "Alert",
          type: "success",
          duration: 10000,
        });

        setIsCalendarDataLoading(true);

        // Wait 30 seconds before fetching
        await delay(60000);

        dispatch(
          FetchAutoNurtureRequest({
            clientName,
            accountName,
            userId: user?.id,
          })
        );
        setIsCalendarDataLoading(false);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const displayTitleDateJsx = (item) => {
    var campaign_title = "";
    var meeting_date = "";
    var meeting_time = "";
    campaign_title = item?.title || "";
    meeting_time =
      (formatDateForRecentDevelopments(item?.start_date, "DD MMM") || "") +
      " to " +
      (formatDateForRecentDevelopments(item?.end_date, "DD MMM") || "");

    return (
      <div className="date-column">
        <div className="">{campaign_title}</div>
        <div className="sub_date">{meeting_time}</div>
      </div>
    );
  };

  // Prepare tab content handlers
  const handleSideCard = useCallback((e, item, tabId) => {
    // console.log(item._id)
    e.preventDefault();
    e.stopPropagation();
    setShowMoreModal(true);
    setSelectedOpportunity({
      opportunityIds: item?.opportunity_ids,
      opportunityId: item._id,
      opportunityInfo: item,
    });
    setCurrentCampaignId(item?._id);
    setCurrRow(item);
    setActiveTab(tabId || "nuture_activity");
  }, []);

  const getAccountsTags = (item, idx) => {
    // const tabConfig = (item?.account || [])?.map((account, i) => ({
    //   key: "account_" + i,
    //   label: account,
    // }));
    const arr = [{key:item?.account,label:item?.account}]
    return (
      <ResizableDivForTag
        handleSideCard={(e) => null}
        items={arr}
        rowData={{}}
      />
    );
  };

  // Filter table data when filters, data or search query changes
  useEffect(() => {
    if (!autoNurtureData) return;

    let filtered = autoNurtureData;

    // Apply filters
    if (Object.keys(filters).length) {
      filtered = filtered.filter((item) =>
        Object.entries(filters).every(([key, values]) => {
          if (!values?.length) return true;
          const itemValue = item[key.toLowerCase()] || item[key];
          return values.includes(itemValue);
        })
      );
    }

    // Apply search filter on contact_name
      if (searchQuery || showExternalOnly) {
        const query = searchQuery?.toLowerCase();

        filtered = filtered.filter((item) => {
          const campaignName = (item.title || item.campaign_name || "").toLowerCase();
          const accountName = (item.account || "").toLowerCase();

          const matchesSearch = query
            ? campaignName.includes(query) || accountName.includes(query)
            : true;

          const matchesExternal = showExternalOnly
            ? item.is_internal === false
            : true;

          return matchesSearch && matchesExternal;
        });
      }


    const enhanced = filtered.map((item) => {
      const handleClick = (e) => handleSideCard(e, item);

      const baseRow = {
        id:item?._id,
        status: (
          <div onClick={handleClick} style={{ cursor: "pointer" }}>
            <ToggleSwitch2
              showTooltip={false}
              meetingId={item._id}
              isActive={!!toggleStates[item?._id]}
              handleToggle={(e) => {
             if (!(item?.status != "in_queue")){
                e.preventDefault();
                e.stopPropagation();
                handleToggle(item?._id);}
              }}
            />
          </div>
        ),
        campaign_name: (
          <div onClick={handleClick} style={{ cursor: "pointer" }}>
         
            {
              item?.title||""
            }
          </div>
        ),
        accounts: (
          <div onClick={handleClick} style={{ cursor: "pointer" }}>
            
            {item?.account ? <TextWithTooltip className="chip_ant gray" text = {item?.account}/> : "N/A"}

          </div>
        ),
        contacts: (
          <div
            className="opp-user-icon-container"
            onClick={handleClick}
            style={{ cursor: "pointer" }}
          >
            <FeatherIcon.Users
              alt="users"
              style={{ color: "#4B84E9", maxHeight: "1.1rem" }}
              className="mr-1"
            />{" "}
            {item?.total_contacts}
          </div>
        ),
        sent: (
          <div onClick={handleClick} style={{ cursor: "pointer" }}>
            {item?.sent_count}
          </div>
        ),
        opened: (
          <div onClick={handleClick} style={{ cursor: "pointer" }}>
            {item?.open_count}
          </div>
        ),
        replied: (
          <div onClick={handleClick} style={{ cursor: "pointer" }}>
            {item?.replied_count}
          </div>
        ),
        bounced: (
          <div onClick={handleClick} style={{ cursor: "pointer" }}>
            {item?.bounced_count}
          </div>
        ),
        result: (
          <div onClick={handleClick} style={{ cursor: "pointer" }}>
      
             <div onClick={(e)=>handleClick}><TagOverflowHandlerV2 data={item?.campaign_result}/> </div>
          </div>
        ),
        start_date: item?.start_date ? formatDateToYMD(new Date(item?.start_date)):"N/A"
        
      };

      return baseRow;
    });

    if (autoNurtureData) {
    }

    setTabData(enhanced);
  }, [
    autoNurtureData,
    filters,
    searchQuery,
    showExternalOnly,
    handleSideCard,
    toggleStates,
  ]);

  useEffect(() => {
    updateMyReportContext();
  }, []);

  // Columns for GenericTable
  const tableColumns = [
    { id: "status", label: "Status", width: 60, alignment: "left" },
    {
      id: "campaign_name",
      label: "Campaign Name",
      width: 250,
      alignment: "left",
    },
    { id: "accounts", label: "Accounts", width: 150, alignment: "center" },
    { id: "contacts", label: "Contacts", width: 80, alignment: "left" },
    { id: "sent", label: "Sent", width: 80, alignment: "left" },
    { id: "opened", label: "Opened", width: 80, alignment: "left" },
    { id: "replied", label: "Replied", width: 80, alignment: "left" },
    { id: "bounced", label: "Bounced", width: 80, alignment: "left" },
    { id: "start_date", label: "Start Date", width: 80, alignment: "left"},
    {
      id: "result",
      label: "Result",
      width: 150,
      clickAction: true,
      alignment: "left",
    },
  ];

  useEffect(() => {
    if (user?.id) {
      let userStat = getUserStatsObject(
        "Auto Nurture",
        "auto_nurture",
        "Page Source: Auto Nurture",
        currentUrl,
        ""
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
    }
  }, [user?.id]);

  if (isCalendarDataLoading == true && isCalendarConnected == true) {
    return (
      <div
        className={`find-opportunities-container ${isMounted ? "mounted" : ""}`}
      >
        <div className="col-md-12 connect_calendar_card mb-3 mt-2">
          <div className="row">
            <div className="col-md-7">
              <div className="connect_calendar_block">
                <div className="connect_calendar_icon">
                  <FeatherIcon.Mail className="calendar_fa" />
                </div>
                <div className="connect_para_block">
                  <p className="connect_calendar_head">
                    Connected to calendar{" "}
                  </p>
                  <p className="connect_para">
                    Outlook Connected, Your campaigns will start appearing here
                    in few minutes
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <span className="connect_calendar_btnblock">
                <Button
                  variant="primary"
                  type="submit"
                  className="pull-right connect_calendar_btn"
                  disabled
                >
                  {" "}
                  <i className="fa fa-spinner fa-spin"></i> Fetching your
                  campaigns{" "}
                </Button>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isCalendarConnected == false && autoNurtureLoading == false) {
    return (
      <div
        className={`find-opportunities-container ${isMounted ? "mounted" : ""}`}
      >
        <div className="col-md-12 connect_calendar_card mb-3 mt-2">
          <div className="row">
            <div className="col-md-6">
              <div className="connect_calendar_block">
                <div className="connect_calendar_icon">
                  <FeatherIcon.Mail className="calendar_fa" />
                </div>
                <div className="connect_para_block">
                  <p className="connect_calendar_head">
                    Connect your calendar{" "}
                  </p>
                  <p className="connect_para">
                    Connect with your Outlook to automate Campaign
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <span className="connect_calendar_btnblock">
                <Button
                  variant="primary"
                  type="submit"
                  className="pull-right connect_calendar_btn"
                  onClick={() => handleOutlookLogin()}
                >
                  {" "}
                  Connect your calendar{" "}
                </Button>
              </span>
            </div>
          </div>
        </div>
        <div className="find-opportunities-results-container">
          <NoDataComp message="See your nurtures , connect your calendar or start fresh." />
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className={`find-opportunities-container ${isMounted ? "mounted" : ""}`}
      >
       {isCalendarConnected == true ? 
       <span
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <h6 className="find-opportunities-results-title">
            {isCalendarConnected && <>Showing {tabData?.length || 0} Campaigns</>}
          </h6>

          {Object.entries(filters).reduce(
            (sum, [key, value]) => sum + (value?.length || 0),
            0
          ) > 0 && (
            <div className="find-opportunities-results-title-filter-badge">
              {Object.entries(filters).reduce(
                (sum, [key, value]) => sum + (value?.length || 0),
                0
              )}{" "}
              filters applied
              <img src="/img/x.png" onClick={() => setFilters({})} />
            </div>
          )}

          <div className="d-flex">
            <span className="spot-contacts-search-input-container">
              <img
                src="/img/search.png"
                className="spot-contacts-search-icon"
              />
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="spot-contacts-search-input"
              />
            </span>

            <span>
              {" "}
              <button
                type="button"
                className="ml-1 add-opportunity-btn d-flex"
                onClick={(e) => {
                  setOpenGenerateNurture(true);
                }}
              >
                <img
                  className=""
                  style={{ marginRight: "5px" }}
                  src="/img/auto_nurture_icon.png"
                  width="14"
                />
                Generate Campaign
              </button>{" "}
            </span>
          </div>
        </span>:<span
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "3rem",
          }}
        ></span>}

        {outlookEmail && <div className="row mt-0">
          <div className="col-md-12 mb-2 text-right align-right">
            <span className="font13" style={{
              fontWeight: '600'
            }}> Connected Email:  </span> <span className="font13 green mr-3">{outlookEmail}</span>  
          </div>
        </div>
        }
        
       {tabData?.length>0 ?
        <div className="find-opportunities-results-container">
          <GenericTable
          loadingRows={15}
          minWidthForDrawer="60%"
            disableSort={true}
            loading={autoNurtureLoading}
            initialColumns={tableColumns}
            tabData={tabData}
            sideCardTabConfig={tabConfig}
            showMoreModal={showMoreModal}
            setShowMoreModal={setShowMoreModal}
            oppName={""}
            titleForSideCard={
              <ScHeaderComp
                key={`side_card_head_comp_${commonProps?.opportunityId}`}
                type="auto_nurture"
                opportunityId={commonProps?.opportunityId}
                data={currRow}
                titlkey={"objective"}
                titlTxt={currRow?.title}
                setShowMoreModal={setShowMoreModal}
                activeTab={activeTab}
              />
            }
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            activeSwitchId={activeSwitchId}
            customComp={
              
                <GenerateNurtureCard
                  campaignID={currentCampaignId}
                  setOpenGenerateNurture={setShowMoreModal}
                />
            
            }
          />
        </div>: 
        (
          <>
          {autoNurtureLoading == true ? ( <>
          {<div className="row">
            <div className=""> <GenericTableSkeleton rowCount={10} colCount={9}/> </div>  
          </div>
          }
          </>) : (<div style={{ padding: "1.2rem" }}>
          <span className="mt-4">
            <NoDataComp message="Create a new Campaign" />
          </span>
          </div>)
          }
          </>
        )
      
      }
      </div>

      <GenericOverviewSideCard
        titleForSideCard={
          <>
          <ScHeaderComp
            key={`side_card_head_comp_${commonProps?.opportunityId}`}
            type="auto_nurture"
            opportunityId={commonProps?.opportunityId}
            data={currRow}
            titlkey={"objective"}
            titlTxt={" "}
            setShowMoreModal={setOpenGenerateNurture}
            activeTab={activeTab}
          />
          </>
        }
        showMoreModal={openGenerateNuture}
        setShowMoreModal={setOpenGenerateNurture}
        comp={
          <>
            <GenerateNurtureCard
              setOpenGenerateNurture={setOpenGenerateNurture}
              campaignID={null}
            />
          </>
        }
        minWidthForDrawer="60%"
        disableXbtn
        preserveState={false}
      />
    </>
  );
}

export default AutoNurture;
